import { Grid } from '@mui/material'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useSelector } from 'react-redux'
import RecentFile from '../Organization/RecentFile'

interface RecentFilesProps {}

const userRecentFilesSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.userRecentFiles,
)

const RecentFilesComponent: React.FC<RecentFilesProps> = ({}) => {
  const useRecentFiles = useSelector(userRecentFilesSelector)

  return (
    <Grid container spacing='1rem'>
      {useRecentFiles?.slice(0, 3).map((recentFile) => {
        return (
          <Grid
            size={4}
            key={recentFile.id}
            sx={{
              boxSizing: 'border-box',
              boxShadow: '0px 2px 10px 0px #0000001A',
              padding: '0.75rem',
              maxHeight: '14.4rem',
              border: '2px solid transparent',
              borderRadius: '0.4rem',
              '&:hover': {
                border: '2px solid #1705E5',
              },
            }}
          >
            <RecentFile fileInfo={recentFile.file} />
          </Grid>
        )
      })}
    </Grid>
  )
}

export default RecentFilesComponent
